<h2 class="ticket__outside-header" aria-hidden="true">
	<span skeletonLoader [translationKey]="'bookingDetails.label.to'">
		<strong>{{ _flight? _flight.departureLocation.city : '' }}</strong>
		<span>
			{{ 'bookingDetails.label.to' | ibeadmin | async}}
		</span>
		<strong>{{ _flight? _flight.arrivalLocation.city : '' }}</strong>
	</span>
</h2>
<article class="ticket vertical ticket-wrapper" [attr.aria-label]="INDRA_printAriaFlight()" role="article"
	tabindex="-1">
	<div class="top">
		<div *ngIf="showTimeInfo" aria-label="'bookingDetails.aria.departureOn' | ibeadmin | async ">
			<span skeletonLoader [translationKey]="'bookingDetails.label.in'">
				<strong>{{ flightDate }}</strong>
				<!-- <span aria-hidden="true"> — </span> -->
				<span aria-hidden="true" *ngIf="timeUnitKey !== ''">
					— {{ 'bookingDetails.label.in' | ibeadmin | async }} 
				</span>
				<span class="flight-eta" *ngIf="timeUnitKey !== ''">
					{{ timeUnitValue }} 
				</span>
				<span class="flight-eta">
					{{ timeUnitKey | ibeadmin | async }}
				</span>
			</span>
		</div>
		<div class="ticket__header-tag" [ngClass]="INDRA_printFlightTagStyle()" *ngIf="INDRA_printFlightTag()" role="status"
			[attr.aria-label]="INDRA_ariaLabelFlightTag()">
			{{ INDRA_printFlightTag() | ibeadmin | async }}
		</div>
		<app-flight-details *ngIf="_flight" [flight]="_flight"></app-flight-details>
	</div>
	<div class="tear-here" aria-hidden="true">
		<div class="left"></div>
		<div class="divider-dashed"></div>
		<div class="right"></div>
	</div>
	<div class="bottom">
		<div class="flight-details__stops_wrapper" *ngIf="INDRA_checkAllStops()">
			<div class="flight-details__stops" id="flight-details__stops_list" role="list" tabindex="0"
				[attr.aria-label]="INDRA_ariaLabelFlightStops()">
				<span *ngFor="let stop of INDRA_getAllStops(); let index = index" class="flight-details__stop" role="listitem">
					<ng-container *ngIf="stop.busStop">
						<span role="listitem" skeletonLoader [translationKey]="'bookingDetails.text.hopOntheBusAt'">
							{{ 'bookingDetails.text.hopOntheBusAt' | ibeadmin | async }} 
							{{ INDRA_printHopDetails(index) | ibeadmin | async }} 
							{{ 'bookingDetails.text.busStation' | ibeadmin | async }} 
						</span>
						<span class="flight-details__stop" role="listitem">
							<span class="flight-details__stop-count" skeletonLoader [translationKey]="'bookingDetails.text.stop'">
								{{'bookingDetails.text.stop' | ibeadmin | async}} {{ index + 1 }}: 
							</span>

							<span skeletonLoader [translationKey]="'bookingDetails.text.layoverIn'">
								{{ INDRA_printTime(stop.stopTime) }} {{'bookingDetails.text.layoverIn' | ibeadmin | async }} 
								{{ booked_trip.translate.locations[stop.arrivalAirport].city }} 
								{{ INDRA_printChangeEquipment(index) | ibeadmin | async }}
							</span>
						</span>
					</ng-container>
					<ng-container *ngIf="getStop(stop) === 1">
						<span class="flight-details__stop-count" skeletonLoader [translationKey]="'bookingDetails.text.stop'">
							{{'bookingDetails.text.stop' | ibeadmin | async}} {{ index + 1 }}: 
						</span>

						<span skeletonLoader [translationKey]="'bookingDetails.text.layoverIn'">
							{{ INDRA_printTime(stop.stopTime) }}
							{{'bookingDetails.text.layoverIn' | ibeadmin | async }}
							{{ booked_trip.translate.locations[stop.arrivalAirport].city }} 
							{{ INDRA_printChangeEquipment(index) | ibeadmin | async }}
						</span>
						
						<span *ngIf="INDRA_nextSegmentHasBusStop(index)" class="flight-details__stop" role="listitem">
							<span skeletonLoader [translationKey]="'bookingDetails.text.hopOfftheBusAt'">
								{{ 'bookingDetails.text.hopOfftheBusAt' | ibeadmin | async }} 
								{{ INDRA_printHopDetails(index) | ibeadmin | async }} 
								{{ 'bookingDetails.text.busStation' | ibeadmin | async }}
							</span>
						</span>
						|
						<span skeletonLoader [translationKey]="'bookingDetails.text.commercialStop'">
							{{ INDRA_printTime(stop.technicalStops[0].duration) }}
							{{ 'bookingDetails.text.commercialStop' | ibeadmin | async }}
						</span> 
					</ng-container>
					<ng-container *ngIf="getStop(stop) === 3">
						<span class="flight-details__stop-count" skeletonLoader [translationKey]="'bookingDetails.text.stop'">
							{{'bookingDetails.text.stop' | ibeadmin | async}} {{ index + 1 }}: 
						</span>

						<span skeletonLoader [translationKey]="'bookingDetails.text.commercialStop'">
							{{ INDRA_printTime(stop.technicalStops[0].duration) }}
							{{ 'bookingDetails.text.commercialStop' | ibeadmin | async }} 
						</span>
					</ng-container>
					<ng-container *ngIf="getStop(stop) === 2">
						<span class="flight-details__stop-count" skeletonLoader [translationKey]="'bookingDetails.text.stop'">
							{{'bookingDetails.text.stop' | ibeadmin | async}} {{ index + 1 }}: 
						</span>

						<span skeletonLoader [translationKey]="'bookingDetails.text.layoverIn'">
							{{ INDRA_printTime(stop.stopTime) }}
							{{'bookingDetails.text.layoverIn' | ibeadmin | async }}
							{{ booked_trip.translate.locations[stop.arrivalAirport].city }} 
							{{ INDRA_printChangeEquipment(index) | ibeadmin | async }}
						</span>

						<span class="flight-details__stop" role="listitem" *ngIf="INDRA_nextSegmentHasBusStop(index)">
							<span skeletonLoader [translationKey]="'bookingDetails.text.hopOfftheBusAt'">
								{{ 'bookingDetails.text.hopOfftheBusAt' | ibeadmin | async }} 
								{{ INDRA_printHopDetails(index) | ibeadmin | async }} 
								{{ 'bookingDetails.text.busStation' | ibeadmin | async }} 
							</span>
						</span>
					</ng-container>
				</span>
			</div>
			<div class="divider-dashed"></div>
		</div>

		<app-flight-check-in *ngIf="!isBookingFlow && INDRA_showCheckInInfo() && breakdownAPIstatus !== 'loading'" 
			class="hide-on-print" 
			[flight_check_in]="INDRA_getCheckinDetails()"
			[dateDeparture]="INDRA_dateInfo(_flight)" 
			[pnrData]="dataPnr">
		</app-flight-check-in>
		<div class="hide-on-print" *ngIf="!isBookingFlow && breakdownAPIstatus === 'loading'">
			<app-loading-shadow [height]="'3rem'" class="bottom-gap"></app-loading-shadow>
		</div>
		
		<div *ngIf="flight?.details?.fareFamily && !this.booked_trip.data.group" class="clearfix extras-flight__brand" style="padding-bottom: 8px">
			<span class="fleft">
				<app-svg 
					[ngClass]="['brand--' + INDRA_getBrand()]" 
					svg="sprite.svg#brand--{{ INDRA_getBrand() }}" 
					[attr.aria-label]="'bookingDetails.aria.flightWith ' + INDRA_getBrand() + 'bookingDetails.aria.flightFare '"
					[alt]="'bookingDetails.aria.flightWith ' + INDRA_getBrand() + 'bookingDetails.aria.flightFare '">
				</app-svg>
			</span>
			<a *ngIf="INDRA_showFareConditions();" 
				class="link-wrapper" 
				(click)="INDRA_handleTicketConditionsClick()" 
				[attr.aria-label]="'bookingDetails.aria.openFareConditionsDetails' | ibeadmin | async "
				href="javascript:;" 
				role="button"
				[attr.aria-label]="'bookingDetails.aria.openFareConditionsDetails' | ibeadmin | async ">
				<p class="text-link fright" skeletonLoader [translationKey]="'bookingDetails.link.fareConditions'">
					{{'bookingDetails.link.fareConditions' | ibeadmin | async}}
				</p>
			</a>
		</div>
		<!--
		<div class="print-only">
			<p class="bottom-message-link-wrapper">{{'bookingDetails.text.changesEurPenalty' | ibeadmin | async}}</p>
			<div class="divider"></div>
			<p class="bottom-message-link-wrapper">{{'bookingDetails.text.notRefundableInCancellation' | ibeadmin | async}}</p>
		</div>
		<div class="divider"></div>
		-->
		<!--
		<div style="padding-bottom: 8px; padding-top: 8px" *ngIf="INDRA_showSSREC()">
			<p>This is the new flight TAP found for you. <a class="link"  href="javascript::" (click)="INDRA_openOriginalFlights()">See original flight</a></p>
			<p><a class="link link--external">Get disruption statement</a></p>
		</div>
		<div class="divider" *ngIf="showIncludedFeatures"></div>
		-->
		<div *ngIf="INDRA_cancelledFlight()" class="select-new-flight-wrapper">
			<!-- <button class="button" (click)="INDRA_handleSelectNewFlight()">
				Select new flight
			</button> -->
			<div class="bottom-message-link-wrapper">
				<span skeletonLoader [translationKey]="'bookingDetails.text.sorryYourFlightIsCancelled'">
					{{'bookingDetails.text.sorryYourFlightIsCancelled' | ibeadmin | async}}. {{'bookingDetails.text.please' | ibeadmin | async}},
					<a (click)="INDRA_gotoURL('externalURLs.contactTAP')" href="javascript:;" class="link link--external">
						{{'bookingDetails.link.contactTap' | ibeadmin | async}}
					</a>
					{{'bookingDetails.text.toFindASolutionForYou' | ibeadmin | async}}
				</span>
			</div>
		</div>
		<div class="extras-included" 
		*ngIf="included_features.length && !INDRA_flownFlight() && !INDRA_noShowFlight() && !INDRA_cancelledFlight() && flight?.details?.fareFamily">
			<app-features-list 
				[attr.aria-label]="'bookingDetails.aria.whatsIncludedInYourFlight' | ibeadmin | async"
				title="{{'bookingDetails.titles.whatsItsIncluded' | ibeadmin | async }}"
				[titleKey]="'bookingDetails.titles.whatsItsIncluded'"
				[features]="included_features"
				(passengerIncluded)="INDRA_handleIncludedPerPassenger()"
				(detailsFeature)="INDRA_handleDetailsFeature($event)"
				[flightId]="flight.details.idFlight"
				[flight_packs]="flight_packs"
			>
			</app-features-list>
		</div>

		<ng-container *ngIf="dupeFlightAncillaries.length != 0">
			<div class="divider"></div>
			<div class="extras-added">
				<h3 class="section-title">{{'bookingDetails.dupe.text.addedToYourTrip' | ibeadmin | async}}</h3>
				<ul>
					<li *ngFor="let extra of dupeFlightAncillaries; let index = index">
						<app-svg aria-hidden="true" class="extras-feature__icon" svg="icons.svg#{{extra.icon}}" attr.tooltip="{{extra.name}}" [alt]="extra.name + ' ' + 'bookingDetails.dupe.alt.icon' | ibeadmin | async"></app-svg>
						<app-svg aria-hidden="true" class="extras-feature__icon--not-available" svg="sprite.svg#status--ok" [alt]="'bookingDetails.dupe.alt.addedIcon' | ibeadmin | async"></app-svg>
						<div class="extras-feature__label">
							<span>{{extra.journey.totalQuantity}} {{extra.name}} {{'bookingDetails.dupe.text.added' | ibeadmin | async}}</span>
							<p class="muted">{{extra.journey.totalPrice.toString() | indracurrency}}</p>
						</div>
					</li>
				</ul>
			</div>
		</ng-container>
		<!-- Start of Bundles Section -->
		<section *ngIf="flight_packs.length > 0" id="bundle_section">
			<div class="header">
				<h3
					class="section-title"
					skeletonLoader
					[translationKey]="'bookingDetails.titles.bundles'"
				>
					{{ 'bookingDetails.titles.bundles' | ibeadmin | async }}
				</h3>
			</div>
			<div class="extras_bundle_container">
				<ng-container *ngFor="let pack of availablePacks">
					<app-bundle-card
						id="{{ pack}}_{{flight.details.idFlight}}"
						[pack]="INDRA_getPackSegments(pack)"
						[bound]="_flight"
						[style.background-image]="INDRA_printImage()"
						[disable]="isDisabled(pack)"
						(add)="INDRA_handleOpenPack(pack)"
					>
					</app-bundle-card>
				</ng-container>
			</div>
		</section>
		<!-- End of Bundles Section -->
		<div class="extras-add hide-on-print" *ngIf="extra_features.length && INDRA_showExtraInfo() && flight?.details?.fareFamily && !isBookingViewFlow">
			<div class="divider"></div>
			<app-features-list *ngIf="!loading_extras && !isDupe" 
				[attr.aria-label]="'bookingDetails.aria.addMoreExtrasToYourFlight' | ibeadmin | async"
				title="{{'bookingDetails.titles.addMoreToFlight' | ibeadmin | async }}"
				[titleKey]="'bookingDetails.titles.addMoreToFlight'"
				[state]="'expanded'" 
				[features]="extra_features"
				[flight]="_flight"
				[flightId]="flight.details.idFlight"
				(addFeature)="INDRA_handleAddFeature($event)"
				[hasUnaccompaniedMinor]="hasUnaccompaniedMinor"
				[allAreUnaccompaniedMinor]="allAreUnaccompaniedMinor">
			</app-features-list>
		</div>
		
		<div class="app-features-list no-margin" *ngIf="loading_extras">
			<div class="header">
				<h3
					class="section-title"
					skeletonLoader
					[translationKey]="'bookingDetails.titles.addMoreToFlight'"
				>
					{{'bookingDetails.titles.addMoreToFlight' | ibeadmin | async }}
				</h3>
			</div>
			<app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
			<app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
			<app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
		</div>
		<div class="flight-options hide-on-print" *ngIf="INDRA_showUpgrade()">
			<div class="divider"></div>
			<app-flight-edit-options 
				[attr.aria-label]="'bookingDetails.aria.upgradeThisFlight' | ibeadmin | async " 
				title="{{'bookingDetails.titles.upgrade' | ibeadmin | async }}"
				[options]="options.upgrade">
			</app-flight-edit-options>
		</div>
		<div class="flight-options hide-on-print" *ngIf="INDRA_showEditChange()">
			<div class="divider"></div>
			<app-flight-edit-options 
				[attr.aria-label]="'bookingDetails.aria.editOrChangeThisFlight' | ibeadmin | async "
				title="{{'bookingDetails.titles.editOrChange' | ibeadmin | async }}"
				[options]="options.change_cancel">
			</app-flight-edit-options>
		</div>

		<!-- Flown flight -->
		<div *ngIf="!isBookingFlow && INDRA_flownFlight() && !INDRA_noShowFlight()" class="bottom-message-link-wrapper">
			<a class="link link--external" target="_blank" [attr.aria-label]="'bookingDetails.aria.goToRefundsPage' | ibeadmin | async"
			(click)="INDRA_gotoURL('externalURLs.claimMiles')" href="javascript:;">
				<span skeletonLoader [translationKey]="'bookingDetails.text.claimMiles'">
					{{'bookingDetails.text.claimMiles' | ibeadmin | async}}
				</span>
			</a>
		</div>

		<!-- Cancelled flight -->
		<div *ngIf="!isBookingFlow && INDRA_cancelledFlight() && INDRA_hasPurchasedAncillaries()" class="cancelled-flight--wrapper">
			<app-features-list 
				title="{{ 'bookingDetails.text.extrasPurchased' | ibeadmin | async }}" 	
				[features]="extra_features_purchased">
			</app-features-list>
			<div class="bottom-message-link-wrapper">
				<span skeletonLoader [translationKey]="'bookingDetails.label.ifExtrasCantAdd'">
					{{'bookingDetails.label.ifExtrasCantAdd' | ibeadmin | async}}
				</span>
			</div>
		</div>
	</div>
</article>
